<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pV"></a>Contents</p>
<p class="contents-1"><a href="#/preface.htm">Preface</a></p>
<p class="linespace"></p>
<p class="contents"><a href="#/part_i_introduction.htm"><i>Part I  Introduction</i></a></p>
<p class="halfline"></p>
<p class="contents"> <a href="#/chapter_one_the_eve_of_battle.htm"><i>Chapter One</i>  The Eve of Battle</a></p>
<p class="contents"> <a href="#/chapter_two_battles_and_battlefields.htm"><i>Chapter Two</i>  Battles and Battlefields</a></p>
<p class="linespace"></p>
<p class="contents"><a href="#/part_ii_the_elements_of_combat.htm"><i>Part II  The Elements of Combat</i></a></p>
<p class="halfline"></p>
<p class="contents"> <a href="#/chapter_three_artillery.htm"><i>Chapter Three</i>  Artillery</a></p>
<p class="contents"> <a href="#/chapter_four_light_infantry.htm"><i>Chapter Four</i>  Light Infantry</a></p>
<p class="contents"> <a href="#/chapter_five_infantry_combat.htm"><i>Chapter Five</i>  Infantry Combat</a></p>
<p class="contents-1"><span class="fsc">ORGANIZATION, FORMATIONS, DRILL AND TRAINING • MUSKETRY • BAYONETS AND HAND-TO-HAND FIGHTING • INFANTRY IN ACTION</span></p>
<p class="contents"> <a href="#/chapter_six_cavalry_combat.htm"><i>Chapter Six</i>  Cavalry Combat</a></p>
<p class="contents-1"><span class="fsc">ORGANIZATION, EQUIPMENT AND TRAINING • CAVALRY IN ACTION • CAVALRY VS CAVALRY • CAVALRY VS ARTILLERY AND INFANTRY</span></p>
<p class="linespace"></p>
<p class="contents"><a href="#/part_iii_command_and_control.htm"><i>Part III  Command and Control</i></a></p>
<p class="halfline"></p>
<p class="contents"> <a href="#/chapter_seven_the_role_of_the_general.htm"><i>Chapter Seven</i>  The Role of the General</a></p>
<p class="contents"> <a href="#/chapter_eight_subordinate_commanders_staff_officers_and_adcs.htm"><i>Chapter Eight</i>  Subordinate Commanders, Staff Officers and ADCs</a></p>
<p class="contents"> <a href="#/chapter_nine_regimental_officers.htm"><i>Chapter Nine</i>  Regimental Officers</a></p>
<p class="contents"> <a href="#/chapter_ten_morale_and_cohesion.htm"><i>Chapter Ten</i>  Morale and Cohesion</a></p>
<p class="contents"> <a href="#/chapter_eleven_attitudes_and_feelings.htm"><i>Chapter Eleven</i>  Attitudes and Feelings</a></p>
<p class="linespace"></p>
<p class="contents"><a id="pVI"></a><a href="#/part_iv_the_end_of_the_day.htm"><i>Part IV  The End of the Day</i></a></p>
<p class="halfline"></p>
<p class="contents"> <a href="#/chapter_twelve_victory_or_defeat.htm"><i>Chapter Twelve</i>  Victory or Defeat?</a></p>
<p class="contents"> <a href="#/chapter_thirteen_after_the_fighting.htm"><i>Chapter Thirteen</i>  After the Fighting</a></p>
<p class="linespace"></p>
<p class="contents-1"><a href="#/epilogue.htm">Epilogue</a></p>
<p class="contents-1"><a href="#/notes.htm">Notes</a></p>
<p class="contents-1"><a href="#/bibliographical_essay.htm">Bibliographical Essay</a></p>
<p class="contents-1"><a href="#/bibliography.htm">Bibliography</a></p>
<p class="contents-1"><a href="#/index.htm">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?361dfce5